module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Phone-dfbe9c6b3e0b99038be28de7ecfdfddc.svg";